/*
 * Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
 * This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
 * The receipt or possession of this program does not convey any rights to use, reproduce or disclose
 * its contents in whole or in part, without the specific written consent of Inovalon, Inc.
 * Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
 * is a violation of the copyright laws and may subject you to criminal prosecution.
 */
import React from 'react'
import { observer } from 'mobx-react'
import './TopPart.scss'
import { NavLink } from 'react-router-dom'
import { TopNavbar } from '../TopNavbar/TopNavbar'
import { SettingsManager } from '../../configuration/SettingsManager'

export interface ITopPartProps {
	pagesource: string
}

@observer
export class TopPart extends React.Component<ITopPartProps> {
	handleUserClickEvent = (event, eventType, eventText) => {
		const text = event.currentTarget.textContent.trim() ? event.currentTarget.textContent.trim() : eventText
		$.ajax({
			url: '/Home/ClickEvent',
			type: 'POST',
			dataType: 'JSON',
			data: { type: eventType, href: event.currentTarget.href, text: text },
			async: false,
			error: function() {
				return true
			},
		})
		return true
	}

	renderHelpPart(): any {
		///Auth/OnlineHelpLink ? articleUrl = /help/pages / coveragediscovery / Request"
		const pattern = new RegExp('^/Auth/OnlineHelpLink?articleUrl=(?:https?://|//|..|[^/]+.[a-z]{2,})') //regex to check vulnerable urls

		if (this.props.pagesource === 'request' && !pattern.test(SettingsManager.REACT_APP_SUPPORT_SITE_REQUEST_PAGE().value)) {
			return (
				<a target="_blank" rel="noopener noreferrer" onClick={e => this.handleUserClickEvent(e, 'Online Help', '?')} href={SettingsManager.REACT_APP_SUPPORT_SITE_REQUEST_PAGE().value}>
					<img src="/coveragediscovery/img/question-sign-help.png" alt="Request" />
				</a>
			)
		} else if (this.props.pagesource === 'history' && !pattern.test(SettingsManager.REACT_APP_SUPPORT_SITE_HISTORY_PAGE().value)) {
			return (
				<a target="_blank" rel="noopener noreferrer" onClick={e => this.handleUserClickEvent(e, 'Online Help', '?')} href={SettingsManager.REACT_APP_SUPPORT_SITE_HISTORY_PAGE().value}>
					<img src="/coveragediscovery/img/question-sign-help.png" alt="History" />
				</a>
			)
		} else if (this.props.pagesource === 'response' && !pattern.test(SettingsManager.REACT_APP_SUPPORT_SITE_RESPONSE_PAGE().value)) {
			return (
				<a target="_blank" rel="noopener noreferrer" onClick={e => this.handleUserClickEvent(e, 'Online Help', '?')} href={SettingsManager.REACT_APP_SUPPORT_SITE_RESPONSE_PAGE().value}>
					<img src="/coveragediscovery/img/question-sign-help.png" alt="Response" />
				</a>
			)
		} else if (this.props.pagesource === 'batches' && !pattern.test(SettingsManager.REACT_APP_SUPPORT_SITE_BATCHES_PAGE().value)) {
			return (
				<a target="_blank" rel="noopener noreferrer" onClick={e => this.handleUserClickEvent(e, 'Online Help', '?')} href={SettingsManager.REACT_APP_SUPPORT_SITE_BATCHES_PAGE().value}>
					<img src="/coveragediscovery/img/question-sign-help.png" alt="Batches" />
				</a>
			)
		} else if (this.props.pagesource === 'facilities' && !pattern.test(SettingsManager.REACT_APP_SUPPORT_SITE_FACILITIES_PAGE().value)) {
			return (
				<a target="_blank" rel="noopener noreferrer" onClick={e => this.handleUserClickEvent(e, 'Online Help', '?')} href={SettingsManager.REACT_APP_SUPPORT_SITE_FACILITIES_PAGE().value}>
					<img src="/coveragediscovery/img/question-sign-help.png" alt="Facilities" />
				</a>
			)
		} else if (this.props.pagesource === 'newfacility' && !pattern.test(SettingsManager.REACT_APP_SUPPORT_SITE_FACILITIES_PAGE().value)) {
			return (
				<a target="_blank" rel="noopener noreferrer" onClick={e => this.handleUserClickEvent(e, 'Online Help', '?')} href={SettingsManager.REACT_APP_SUPPORT_SITE_FACILITIES_PAGE().value}>
					<img src="/coveragediscovery/img/question-sign-help.png" alt="New Facility" />
				</a>
			)
		} else if (this.props.pagesource === 'editfacility' && !pattern.test(SettingsManager.REACT_APP_SUPPORT_SITE_FACILITIES_PAGE().value)) {
			return (
				<a target="_blank" rel="noopener noreferrer" onClick={e => this.handleUserClickEvent(e, 'Online Help', '?')} href={SettingsManager.REACT_APP_SUPPORT_SITE_FACILITIES_PAGE().value}>
					<img src="/coveragediscovery/img/question-sign-help.png" alt="Edit Facility" />
				</a>
			)
		}
	}
	renderBreadCrumb(): React.ReactNode {
		if (this.props.pagesource === 'request') {
			return (
				<>
					<li className="breadcrumb-item" aria-current="page">
						Request
					</li>
				</>
			)
		} else if (this.props.pagesource === 'history') {
			return (
				<>
					<li className="breadcrumb-item" aria-current="page">
						History
					</li>
				</>
			)
		} else if (this.props.pagesource === 'response') {
			return (
				<>
					<li className="breadcrumb-item" aria-current="page">
						Response
					</li>
				</>
			)
		} else if (this.props.pagesource === 'batches') {
			return (
				<>
					<li className="breadcrumb-item" aria-current="page">
						Batches
					</li>
				</>
			)
		} else if (this.props.pagesource === 'facilities') {
			return (
				<>
					<li className="breadcrumb-item" aria-current="page">
						Facilities
					</li>
				</>
			)
		} else if (this.props.pagesource === 'newfacility') {
			return (
				<>
					<li className="breadcrumb-item">
						<NavLink to="/facilities"> Facilities </NavLink>
					</li>
					<li className="breadcrumb-item" aria-current="page">
						New Facility
					</li>
				</>
			)
		} else if (this.props.pagesource === 'editfacility') {
			return (
				<>
					<li className="breadcrumb-item">
						<NavLink to="/facilities"> Facilities </NavLink>
					</li>
					<li className="breadcrumb-item" aria-current="page">
						Edit Facility
					</li>
				</>
			)
		}
	}

	renderLabelTextHTML(headingText: string, labelText: string, message?: string): any {
		return (
			<>
				<h2>{headingText}</h2>
				<label>{labelText}</label>
				{message && <div className="facility-message" dangerouslySetInnerHTML={{ __html: message }} />}
			</>
		)
	}

	renderLabelText(): any {
		const messageText = 'For any new NPIs, please reach out to our support team (<a href="mailto:support@inovalon.com">support@inovalon.com</a>) or open a case, providing the facility name, NPI, EIN, address, city, state and zip code. Thank you.'

		if (this.props.pagesource === 'request') {
			return this.renderLabelTextHTML('Insurance Discovery Request', 'Create a new Insurance Discovery Request')
		} else if (this.props.pagesource === 'history') {
			return this.renderLabelTextHTML('Insurance Discovery Request History', 'Search, filter and review your past Insurance Discovery requests')
		} else if (this.props.pagesource === 'response') {
			return this.renderLabelTextHTML('Insurance Discovery Response', 'Review your past Insurance Discovery response')
		} else if (this.props.pagesource === 'batches') {
			return this.renderLabelTextHTML('Insurance Discovery Batches', 'Create, filter and search Insurance Discovery Batches')
		} else if (this.props.pagesource === 'facilities') {
			return this.renderLabelTextHTML('Insurance Discovery Facilities', 'Create, edit and search Insurance Discovery Facilities', messageText)
		} else if (this.props.pagesource === 'newfacility') {
			return this.renderLabelTextHTML('New Insurance Discovery Facility', 'Create a new Insurance Discovery Facility', messageText)
		} else if (this.props.pagesource === 'editfacility') {
			return this.renderLabelTextHTML('Edit Insurance Discovery Facility', 'Edit an existing Insurance Discovery Facility', messageText)
		}
	}

	navigate(): void {
		window.location.href = '/'
	}

	render(): React.ReactNode {
		return (
			<div>
				<div className="breadcrumb-main">
					<nav aria-label="breadcrumb">
						<table className="breadcrumb-main helpClass">
							<tbody>
								<tr>
									<td>
										<ol className="breadcrumb">
											<li className="breadcrumb-item active" aria-current="page">
												<NavLink to="/coveragediscoveryrequest/"> Insurance Discovery </NavLink>
											</li>{' '}
											{this.renderBreadCrumb()}
										</ol>
									</td>
									<td>{this.renderHelpPart()}</td>
								</tr>
							</tbody>
						</table>
					</nav>
					<div className="requestHeader">{this.renderLabelText()}</div>
				</div>
				<TopNavbar />
			</div>
		)
	}
}
